export enum API_TYPE {
    GET = 'get',
    POST = 'post',
    POSTFORMDATA = 'postFormData',
}

export interface IApi {
    url: string;
    type: API_TYPE;
}

const circleBaseApi = '/uapi/v1/learning-circle';

const API = Object.assign({
    LOGOUT: {
        url: '/ajax/logout',
        type: API_TYPE.POST
    },

    // 获取登录过的账户列表
    GET_LOGIN_ACCOUNTS: {
        url: '/uapi/v1/user/get-login-accounts',
        type: API_TYPE.GET
    },

    SWITCH_ACCOUNT: {
        url: '/uapi/v1/user/switch-account',
        type: API_TYPE.GET
    },

    DELETE_ACCOUNT: {
        url: '/uapi/v1/user/delete-account',
        type: API_TYPE.GET
    },
    GET_UNREAD_COUNT: {
        url: '/uapi/v1/message/get-unread-count',
        type: API_TYPE.GET
    },
    // 获取当前用户的账号版本信息
    GET_ACCOUNT_PLAN: {
        url: '/uapi/v1/user/account-plan',
        type: API_TYPE.GET,
    },
    // 获取企业购买学习圈数
    GET_CIRCLE_ENTERPRISE_CLONE_NUM: {
        url: `${circleBaseApi}/enterprise-clone-circle-num`,
        type: API_TYPE.GET,
    },
    // 企业测评权限信息
    GET_ENTERPRISE_INFO: {
        url: '/uapi/v1/enterprise/info',
        type: API_TYPE.GET,
    },
    // 获取学习圈设置
    GET_CIRCLE_SETUP_SINGLE: {
        url: `${circleBaseApi}/setting`,
        type: API_TYPE.GET,
    },
    // 当前账户是否有权限展示学习圈入口
    GET_CIRCLE_ENTRY_ACCESS: {
        url: `${circleBaseApi}/enterprise-circle-entry-access`,
        type: API_TYPE.GET,
    },
    STAT_LOG: {
        url: `/uapi/v1/stat/log`,
        type: API_TYPE.POST,
    },
    UPDATE_GUIDE_STATUS: {
        url: `/uapi/v1/guide/upd-status`,
        type: API_TYPE.POST,
    },
    CHANGE_LANGUAGE: {
        url: `/api/user/updatesetup`,
        type: API_TYPE.POST,
    },
    CHANGE_FONT_SIZE: {
        url: `/api/user/updatesetup`,
        type: API_TYPE.POST,
    },
},{}
);

export default API;
